import { useRef } from 'react';

import type { ToolbarHanderRef } from '../types.js';

export const useToolbarHandlerRef = () => {
  const handlerRef = useRef<ToolbarHanderRef>({
    handleFocus: () => null,
  });

  return handlerRef;
};
